import Trend from './trend.vue';
export default Trend;


// WEBPACK FOOTER //
// ./src/components/trend/index.js